import React from "react";
import {
    ContentSection,
    GridRow,
    GridColumn,
    ListTable,
    Grid,
    SearchBox,
    Stack,
    ClearFiltersButton,
    ButtonRenderProps,
    ButtonProps
} from "sprint-common-web";

import { SyncAirlinesButton } from "../sync/SyncAirlinesButton";
import { createAirlineListingColumns } from "./createAirlineListingColumns";
import { useAirlineListing } from "./hooks/useAirlineListing";
import { useAirlineListingFilters } from "./hooks/useAirlineListingFilters";

export const AirlineListing: React.FC = () => {
    const { filters, setSort, setPage, setPageSize, setName, setCode, clearFilters } = useAirlineListingFilters();
    const { items, totalItems, isLoading } = useAirlineListing(filters);
    const columns = createAirlineListingColumns();

    const updateAirlinesButtonProps: ButtonRenderProps<ButtonProps> = {
        render: SyncAirlinesButton
    };

    return (
        <ContentSection header={"Airlines"} buttons={[updateAirlinesButtonProps]}>
            <Grid>
                <GridRow>
                    <GridColumn sm={3}>
                        <SearchBox placeholder="Name" onChange={setName} value={filters.name} />
                    </GridColumn>
                    <GridColumn sm={3}>
                        <SearchBox placeholder="Code" onChange={setCode} value={filters.code} />
                    </GridColumn>
                    <GridColumn sm={6}>
                        <Stack horizontalAlign="end">
                            <ClearFiltersButton onClear={clearFilters} isLabeled={true} />
                        </Stack>
                    </GridColumn>
                </GridRow>
                <GridRow>
                    <GridColumn sm={12}>
                        <ListTable
                            columns={columns}
                            items={items}
                            pagination={{
                                ...filters,
                                totalItems,
                                onPageChange: setPage,
                                onPageSizeChange: setPageSize
                            }}
                            sort={{ by: filters.sortBy, order: filters.sortOrder }}
                            onSortChange={setSort}
                            isLoading={isLoading}
                        />
                    </GridColumn>
                </GridRow>
            </Grid>
        </ContentSection>
    );
};
